import {Component, EventEmitter, Input, Output} from "@angular/core";
import {StandardName} from "../../../store/state/order.state";

@Component({
	selector: 'standard-button',
	template: `
		@if (isSelected) {
			<button id="{{standardName}}_button" [ngClass]="{'selected': isSelected}" nbButton status="primary" (click)="selectStandard()" [disabled]="disabled">
				<span>{{ standardName.toString().replace('_', ' ') }}</span>
				<nb-icon icon="checkmark-outline"></nb-icon>
			</button>
		} @else {
			<button id="{{standardName}}_button" nbButton status="primary" [ngClass]="{'selected': isSelected}" outline (click)="selectStandard()" [disabled]="disabled">
				<span>{{ standardName.toString().replace('_', ' ') }}</span>
			</button>
		}

	`,
	styleUrls: ['./standard-button.style.scss'],
	standalone: false
})
export class StandardButtonComponent {

	@Input() isSelected: boolean;
	@Input() disabled: boolean;
	@Input() standardName: StandardName | string;
	@Output() onStandardSelected: EventEmitter<boolean> = new EventEmitter<boolean>();

	selectStandard() {
		this.onStandardSelected.emit(!this.isSelected);
	}
}
